import styled, { css } from 'styled-components';

const FormStyled = styled.form`
  ${({ theme, useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
        css`
          > div:not(:first-child) {
            margin-top: 16px;
          }
          padding: 0 16px;
          .success-message {
            font-size: 18px;
            margin: 0;
          }
          .visuallyHidden {
            position: absolute;
            left: -10000px;
            top: auto;
            width: 1px;
            height: 1px;
            overflow: hidden;
          }
          .loading {
            display: block;
            margin: 24px auto;
          }
          label {
            display: inline-block;
            .isRequired {
              color: ${theme.colors.red_darker};
            }
          }
          input,
          textarea,
          select {
            display: block;
            font-family: inherit;
            background-color: ${theme.colors.white};
            border-radius: 3px;
            border: 1px solid ${theme.colors.light_grey_darkest};
            height: 40px;
            padding: 8px;
            margin-top: 4px;
            width: 100%;
          }
          input:-webkit-autofill,
          input:-webkit-autofill:hover, 
          input:-webkit-autofill:focus, 
          input:-webkit-autofill:active{
              -webkit-box-shadow: 0 0 0 30px ${theme.colors.white} inset;
          }
          textarea {
            height: 200px;
            resize: none;
          }
          [aria-invalid='false']{
            background: ${theme.colors.green_lightest};
            border: 1px solid ${theme.colors.green_darker};
            &:-webkit-autofill,
            &:-webkit-autofill:hover, 
            &:-webkit-autofill:focus, 
            &:-webkit-autofill:active{
                -webkit-box-shadow: 0 0 0 30px${theme.colors.green_lightest} inset;
            }
          }
          [aria-invalid='true']{
            background: ${theme.colors.red_lightest};
            border: 1px solid ${theme.colors.red_darker};
            &:-webkit-autofill,
            &:-webkit-autofill:hover, 
            &:-webkit-autofill:focus, 
            &:-webkit-autofill:active{
                -webkit-box-shadow: 0 0 0 30px${theme.colors.red_lightest} inset;
            }
          }
          input ~ .svg {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
          }
          textarea ~ .svg {
            position: absolute;
            right: 8px;
            top: 8px;
          }
          button:not(:last-of-type) {
            margin-right: 16px;
          }
        `}
    `;
  }};
`;

export default FormStyled;
